import { Box, CircularProgress } from '@mui/material';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner = ({ size = 40, color = 'primary', fullScreen = false }: LoadingSpinnerProps) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
        }}
      >
        <CircularProgress
          size={size}
          color={color === 'primary' ? 'primary' : undefined}
          sx={{ color: color !== 'primary' ? color : undefined }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <CircularProgress
        size={size}
        color={color === 'primary' ? 'primary' : undefined}
        sx={{ color: color !== 'primary' ? color : undefined }}
      />
    </Box>
  );
};
